<template>
  <div class="layout">
    <Header />
    <div class="main">
      <transition appear name="fade-transform" mode="out-in">
        <el-scrollbar class="scrollbar-wrapper" style="height: 100%;">
          <router-view></router-view>
        </el-scrollbar>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Header: () => import("./components/Header.vue"),
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.layout {
  width: 100%;
  height: 100%;
  background: rgb(240, 240, 240);

  .main {
    padding: 0;
    // background: rgb(240, 240, 240);
    width: 100%;
    height: calc(100% - 64px);
    // height: 100%;
  }
}
</style>
